import { GridProps, useTheme } from '@mui/material';
import { FinalGridContainer, FinalGridItem } from '@portals/core/src/components/FinalGrid/FinalGrid';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import type { TypographyProps } from '@portals/core/src/components/Typography/Typography.types';
import type { Theme } from '@portals/core/src/themes/themes';
import React from 'react';

import { getStyles } from './LegalFooterServiceLink.styles';

interface ServiceLinkProps {
  children: React.ReactNode;

  component?: 'div' | 'button' | 'a';
  href?: HTMLAnchorElement['href'];
  target?: HTMLAnchorElement['target'];
  rel?: HTMLAnchorElement['rel'];
  onClick?: GridProps['onClick'];
  primaryTypographyVariant?: TypographyProps['variant'];
  primaryTypographyFontWeight?: TypographyProps['fontWeight'];
}

export const LegalFooterServiceLink: React.FC<ServiceLinkProps> = ({
  children,
  primaryTypographyVariant = 'button',
  primaryTypographyFontWeight = '600',
  ...props
}: ServiceLinkProps) => {
  const theme = useTheme<Theme>();
  const styles = getStyles(theme);

  return (
    <FinalGridContainer {...props} columnGap={0} rowGap={0} sx={styles.container} component="li">
      <FinalGridItem md={12} lg={12} innerPadding="both">
        <Typography variant={primaryTypographyVariant} sx={styles.text} fontWeight={primaryTypographyFontWeight}>
          {children}
        </Typography>
      </FinalGridItem>
    </FinalGridContainer>
  );
};
